import { render, staticRenderFns } from "./RequestListItem.vue?vue&type=template&id=4af59b57"
import script from "./RequestListItem.vue?vue&type=script&lang=js"
export * from "./RequestListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports